import { IntegrationApiFeaturesServiceAvailabilityContractsResponsesGetServiceAvailabilityDetailsResponse as APIOutageResponse } from '@alliander-fe/api';

import { AddressDataProps, NetworkCheckFormProps } from '..';

import { getAddressReplaceText } from './getAddressReplaceText';
import { mappedNetworkAvailability } from './mappedNetworkAvailability';
import { replaceUrlParameters } from './replaceUrlParameters';
import { mappedNetworkOutages } from './mappedNetworkOutages';
import { mappedNetworkOutagesInPostalCodeArea } from './mappedNetworkOutagesInPostalCodeArea';

type HandleSuccesRequestProps = {
  address: AddressDataProps;
} & Omit<APIOutageResponse, 'address'> &
  Omit<NetworkCheckFormProps, 'color'>;

export const handleAddressSuccessRequest = ({
  address,
  outageNumber,
  electricityNetwork,
  gasNetwork,
  featureToggle,
  networkCheck,
  outagesRetrievedWithPartialPostalCode,
}: HandleSuccesRequestProps) => {
  const isOperationalElectricity = Boolean(electricityNetwork?.isOperational);
  const isOperationalGas = Boolean(gasNetwork?.isOperational);
  const isHealthyElectricity = Boolean(electricityNetwork?.isHealthy);
  const isHealthyGas = Boolean(gasNetwork?.isHealthy);

  const isOperational = isOperationalElectricity || isOperationalGas;

  const replaceText = getAddressReplaceText({
    city: address?.city,
    postalCode: address?.postalCode,
    houseNumber: address?.houseNumber,
    houseNumberAddition: address?.houseNumberAddition,
  });

  // Maps the response to the correct response for the view
  const networkAvailability = featureToggle?.networkCheck
    ? mappedNetworkAvailability({
        networkCheck,
        isOperationalElectricity,
        isOperationalGas,
        replaceText: { ...replaceText },
      })
    : undefined;

  // Create the the url query parameters for the outage check url
  const replaceTextOutage = replaceUrlParameters({
    ...address,
    reference: outageNumber,
  });

  const mapNetworkOutage = featureToggle?.outageCheck && isOperational;

  // Maps the response to the correct response for the view
  const networkOutage =
    mapNetworkOutage && !outagesRetrievedWithPartialPostalCode
      ? mappedNetworkOutages({
          networkCheck,
          isHealthyElectricity,
          isHealthyGas,
          replaceText: { ...replaceText, ...replaceTextOutage },
        })
      : undefined;

  // Maps the response to the correct response for the view
  const networkOutageInPostalCodeArea =
    mapNetworkOutage && outagesRetrievedWithPartialPostalCode
      ? mappedNetworkOutagesInPostalCodeArea({
          networkCheck,
          isHealthyElectricity,
          isHealthyGas,
          replaceText: { ...replaceText, ...replaceTextOutage },
        })
      : undefined;

  return {
    networkAvailability,
    networkOutage: networkOutage ?? networkOutageInPostalCodeArea,
    isOperational,
  };
};
